import css from 'styled-jsx/css';
import { screen, colors } from 'components/styles/variables';

export default css`
  .rating-section {
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${screen.mdMin}) {
    .rating-section {
      flex-direction: row;
      margin-bottom: 25px;
    }
  }

  .rating-summary {
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${screen.smMin}) {
    .rating-summary {
      flex-direction: row;
      border: 2px solid ${colors.G1};
      border-radius: 15px;
      padding: 30px;
    }
  }

  @media (min-width: ${screen.mdMin}) {
    .rating-summary {
      width: 72.5%;
    }
  }

  .top-section {
    display: flex;
    flex-direction: row;
    margin-bottom: 12px;
  }

  @media (min-width: ${screen.smMin}) {
    .top-section {
      margin-bottom: 0;
    }
  }

  .recommendation-percentage {
    padding: 10px 0;
    width: 110px;
  }

  @media (min-width: ${screen.smMin}) {
    .recommendation-percentage {
      padding: 0;
      display: flex;
      justify-content: center;
      width: 30%;
    }
  }

  .overall-experience {
    padding: 13px 0 10px 30px;
  }

  @media (min-width: ${screen.smMin}) {
    .overall-experience {
      padding: 13px 0 10px 56px;
    }
  }

  @media (min-width: ${screen.mdMin}) {
    .overall-experience {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      padding: 0 0 0 9px;
      width: 70%;
    }
  }

  .submit-review {
    margin: 25px 0;
  }

  @media (min-width: ${screen.mdMin}) {
    .submit-review {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      margin: 0;
      width: 27.5%;
    }
  }
`;
